import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('reports');

export const apiRoutes = {
  //reports autocomplete api
  usersAutoComplete: `${URI_PREFIX}/activated`,
  blockedUsersAutoComplete: `${URI_PREFIX}/blocked`,
  trashedUsersAutoComplete: `${URI_PREFIX}/trashed`,
  getTemplateData: `${URI_PREFIX}/templates/show`,
  saveTemplate: `${URI_PREFIX}/templates/store`,
  updateTemplate: `${URI_PREFIX}/templates/update`,
  getModuleCharts: `${URI_PREFIX}/templates/modules/charts`,
  getItemSortOptions: `${URI_PREFIX}/templates/modules/item-sort-types`,
  getTweetTypesOptions: `${URI_PREFIX}/tweet-types`,
  getInstagramPostsTypesOptions: `${URI_PREFIX}/instagram/post-types`,
  defaultHashtagsIds: `${URI_PREFIX}/hashtags/last-item`,
  defaultInfluencersIds: `${URI_PREFIX}/influencers/platforms/sample`,
  infInfoOptions: `${URI_PREFIX}/influencers/information/sections`,
  getPostsTypesOptions: `${URI_PREFIX}/post-types`,

  storeReport: `${URI_PREFIX}/store`,
  showReport: `${URI_PREFIX}/show`,
  updateReport: `${URI_PREFIX}/update`,
  activateReport: `${URI_PREFIX}/activate`,
  activeTemplates: `${URI_PREFIX}/templates/not-in-item`,
  activeTemplatesDownload: `${URI_PREFIX}/templates/in-item`,
  storeComment: `${URI_PREFIX}/comments/store`,
  deleteComment: `${URI_PREFIX}/comments/delete`,
  updateComment: `${URI_PREFIX}/comments/update`,
  // reports table
  activeTab: `users/all-activated`,
  /****** TEMPLATES TABLE ***********/
  templatesActiveTab: `${URI_PREFIX}/templates/active/all`,
  templatesTrashTab: `${URI_PREFIX}/templates/trash/all`,
  // templates table autocomplete apis
  activeTemplatesAutoComplete: `${URI_PREFIX}/templates/active`,
  trashTemplatesAutoComplete: `${URI_PREFIX}/templates/trash`,
  // templates table actions
  trashTemplate: `${URI_PREFIX}/templates/trash`,
  restoreTemplate: `${URI_PREFIX}/templates/restore`,
  deleteTemplate: `${URI_PREFIX}/templates/delete`,
  copyTemplate: `${URI_PREFIX}/templates/copy`,
  /****** TEMPLATES DETAILS ***********/
  getTemplate: `${URI_PREFIX}/templates/show`,
  getTemplateToReport: `${URI_PREFIX}/templates/show-to-report`,
  getTemplateReports: `${URI_PREFIX}/all`,
  getTrashedTemplateReports: `${URI_PREFIX}/trashed`,
  reportsTemplateAutoComplete: `${URI_PREFIX}/all`,
  trashedReportsTemplateAutoComplete: `${URI_PREFIX}/trashed`,
  deleteReports: `${URI_PREFIX}/delete`,
  restoreReports: `${URI_PREFIX}/restore`,
  trashReports: `${URI_PREFIX}/trash`,
  deActiveReport: `${URI_PREFIX}/deactive`,
  deActiveAllReport: `${URI_PREFIX}/deactive/all`,
  activeReport: `${URI_PREFIX}/active`,
  fastReport: `${URI_PREFIX}/items/fast/download`,
  /****** REPORT VERSIONS TABLE ***********/
  reportVersions: `${URI_PREFIX}/versions/all`,
  getReportHistory: `${URI_PREFIX}/history`,
  getEditReportTableOptions: `${URI_PREFIX}/templates/related-to-item`,
  getEditReportTableOptionsCount: `${URI_PREFIX}/templates/related-to-item/all/count`,
  reportsVersionsCount: `${URI_PREFIX}/versions/count`,
};
